import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendar = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 73,
	height: 75,
	viewBox: "0 0 73 75",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M63.2755 7.37637H60.95V4.4649C60.95 3.22038 59.9416 2.21204 58.6971 2.21204C57.4526 2.21204 56.4443 3.22038 56.4443 4.4649V7.37637H45.9248V4.4649C45.9248 3.22038 44.9165 2.21204 43.672 2.21204C42.4274 2.21204 41.4191 3.22038 41.4191 4.4649V7.37637H30.8997V4.4649C30.8997 3.22038 29.8913 2.21204 28.6468 2.21204C27.4023 2.21204 26.3939 3.22038 26.3939 4.4649V7.37637H15.8745V4.4649C15.8745 3.22038 14.8662 2.21204 13.6216 2.21204C12.3771 2.21204 11.3688 3.22038 11.3688 4.4649V7.37637H9.04324C5.26879 7.37637 2.21198 10.4377 2.21198 14.2076V65.0697C2.21198 68.8442 5.27333 71.901 9.04324 71.901H63.2892C67.0636 71.901 70.1204 68.8396 70.1204 65.0697V14.2076C70.1204 10.4332 67.0591 7.37637 63.2892 7.37637H63.2755Z",
			stroke: "white",
			strokeWidth: 4.42397,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.846 17.873L2.19818 28.3698V65.0742C2.19818 68.8487 5.25953 71.9055 9.02945 71.9055H63.2754C67.0498 71.9055 70.1066 68.8441 70.1066 65.0742V28.3698L47.846 17.873Z",
			fill: "url(#paint0_linear_43_250)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M70.1112 14.2076C70.1112 10.4332 67.0498 7.37634 63.2799 7.37634H9.02945C5.25499 7.37634 2.19818 10.4377 2.19818 14.2076V28.3698H70.1112V14.2076Z",
			fill: "url(#paint1_linear_43_250)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.6078 18.6225C15.9809 18.6225 17.9046 16.6988 17.9046 14.3257C17.9046 11.9527 15.9809 10.0289 13.6078 10.0289C11.2348 10.0289 9.31104 11.9527 9.31104 14.3257C9.31104 16.6988 11.2348 18.6225 13.6078 18.6225Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.6124 2.20752H13.6078C12.3636 2.20752 11.355 3.21616 11.355 4.46039V14.3258C11.355 15.57 12.3636 16.5786 13.6078 16.5786H13.6124C14.8566 16.5786 15.8653 15.57 15.8653 14.3258V4.46039C15.8653 3.21616 14.8566 2.20752 13.6124 2.20752Z",
			fill: "url(#paint2_linear_43_250)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.6376 18.6225C31.0106 18.6225 32.9344 16.6988 32.9344 14.3257C32.9344 11.9527 31.0106 10.0289 28.6376 10.0289C26.2645 10.0289 24.3408 11.9527 24.3408 14.3257C24.3408 16.6988 26.2645 18.6225 28.6376 18.6225Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.6421 2.20752H28.6376C27.3933 2.20752 26.3847 3.21616 26.3847 4.46039V14.3258C26.3847 15.57 27.3933 16.5786 28.6376 16.5786H28.6421C29.8863 16.5786 30.895 15.57 30.895 14.3258V4.46039C30.895 3.21616 29.8863 2.20752 28.6421 2.20752Z",
			fill: "url(#paint3_linear_43_250)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.6672 18.6225C46.0403 18.6225 47.964 16.6988 47.964 14.3257C47.964 11.9527 46.0403 10.0289 43.6672 10.0289C41.2942 10.0289 39.3704 11.9527 39.3704 14.3257C39.3704 16.6988 41.2942 18.6225 43.6672 18.6225Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.6718 2.20752H43.6672C42.423 2.20752 41.4144 3.21616 41.4144 4.46039V14.3258C41.4144 15.57 42.423 16.5786 43.6672 16.5786H43.6718C44.916 16.5786 45.9246 15.57 45.9246 14.3258V4.46039C45.9246 3.21616 44.916 2.20752 43.6718 2.20752Z",
			fill: "url(#paint4_linear_43_250)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M58.6969 18.6225C61.07 18.6225 62.9937 16.6988 62.9937 14.3257C62.9937 11.9527 61.07 10.0289 58.6969 10.0289C56.3239 10.0289 54.4001 11.9527 54.4001 14.3257C54.4001 16.6988 56.3239 18.6225 58.6969 18.6225Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M58.7015 2.20752H58.697C57.4527 2.20752 56.4441 3.21616 56.4441 4.46039V14.3258C56.4441 15.57 57.4527 16.5786 58.697 16.5786H58.7015C59.9457 16.5786 60.9544 15.57 60.9544 14.3258V4.46039C60.9544 3.21616 59.9457 2.20752 58.7015 2.20752Z",
			fill: "url(#paint5_linear_43_250)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.3354 59.2059V55.0454C19.3354 54.1778 19.4762 53.4193 19.7669 52.7698C20.053 52.1248 20.5118 51.5434 21.1386 51.0347C21.7654 50.526 22.5966 50.0491 23.6322 49.6085L26.9025 48.1959C27.7337 47.8462 28.3468 47.4102 28.7465 46.8924C29.1417 46.3746 29.3416 45.7205 29.3416 44.9256C29.3416 44.1308 29.0917 43.4449 28.5921 42.9271C28.0925 42.4093 27.3612 42.1504 26.4028 42.1504C25.4445 42.1504 24.7132 42.4184 24.2136 42.9544C23.7139 43.4903 23.4641 44.2125 23.4641 45.1164H19.0538C19.0538 43.8401 19.3308 42.6909 19.885 41.6644C20.4391 40.6379 21.2612 39.8294 22.3513 39.239C23.4414 38.6485 24.7904 38.3533 26.3983 38.3533C28.0062 38.3533 29.3506 38.6394 30.4317 39.2117C31.5127 39.784 32.3348 40.5516 32.898 41.5146C33.4612 42.4775 33.7428 43.5585 33.7428 44.7576V45.0892C33.7428 46.6425 33.3159 47.9234 32.4665 48.9317C31.6171 49.9401 30.3045 50.8303 28.5285 51.607L25.2855 53.0196C24.7314 53.2603 24.3362 53.5101 24.1091 53.769C23.8774 54.0279 23.7639 54.3777 23.7639 54.8228V56.2081L22.6829 55.2952H33.7746V59.2059H19.3263H19.3354Z",
			fill: "#8B4A37"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.1092 55.3224V50.5805L43.7899 38.3805L47.31 40.6833L40.7376 51.1392L41.1237 51.7205H53.2419V55.3269H36.1047L36.1092 55.3224ZM46.7331 59.2059V44.6213H50.9209V59.2059H46.7331Z",
			fill: "#8B4A37"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_43_250",
				x1: 36.1547,
				y1: 34.2154,
				x2: 36.1547,
				y2: 25.3266,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#D7E8EA" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .26,
						stopColor: "#D3E4E6"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .49,
						stopColor: "#C9D9DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .72,
						stopColor: "#B8C6C8"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .94,
						stopColor: "#A0ACAE"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#98A4A6"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_43_250",
				x1: 36.1547,
				y1: 26.8118,
				x2: 36.1547,
				y2: -12.1818,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#F2D455" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .15,
						stopColor: "#EBBA4A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .39,
						stopColor: "#E1973B"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .62,
						stopColor: "#DB7E31"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .83,
						stopColor: "#D76F2B"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#D66A29"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_43_250",
				x1: 13.6078,
				y1: 16.3697,
				x2: 13.6078,
				y2: 2.06217,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .18,
						stopColor: "#40201C"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .55,
						stopColor: "#633328"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .92,
						stopColor: "#8B4A37"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_43_250",
				x1: 28.6376,
				y1: -4.08779,
				x2: 28.6376,
				y2: -4.08779,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .18,
						stopColor: "#40201C"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .55,
						stopColor: "#633328"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .92,
						stopColor: "#8B4A37"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_43_250",
				x1: 43.6672,
				y1: -4.08779,
				x2: 43.6672,
				y2: -4.08779,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .18,
						stopColor: "#40201C"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .55,
						stopColor: "#633328"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .92,
						stopColor: "#8B4A37"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint5_linear_43_250",
				x1: 58.697,
				y1: -4.08779,
				x2: 58.697,
				y2: -4.08779,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .18,
						stopColor: "#40201C"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .55,
						stopColor: "#633328"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .92,
						stopColor: "#8B4A37"
					})
				]
			})
		] })
	]
});
export default SvgCalendar;
